import React from 'react';
import { Card, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';
import { Carousel } from '@one-thd/sui-carousel';
import { RecentOrdersCardHeader } from '../../subcomponents/cardHeader/RecentOrdersHeader';
import { CardItemsPlaceholder } from '../orderDetailsLoading/CardItemsPlaceholder';

export function RecentOrdersCardPlaceholder() {
  const totalOrders = 1;

  let cardContent = [];

  for (let i = 0; i < totalOrders; i += 1) {
    cardContent.push(
      <div
        key={`recentOrdersCardContent${i}`}
        role="group"
        data-testid="placeholderCardWrapper"
        className="sui-w-full sui-h-full sui-flex sui-flex-col sui-border-1 sui-border-solid sui-border-primary sui-rounded-sm"
      >
        <div
          className="sui-p-4"
          key={`recentOrdersCarouselSectionOne${i}`}
        >
          <div>
            <div className="sui-pt-2">
              <SkeletonLine fullWidth variant="single" />
            </div>
            <div className="sui-pt-2">
              <SkeletonLine variant="single" />
            </div>
            <div className="sui-pt-2">
              <SkeletonLine variant="single" />
            </div>
          </div>
          <div className="sui-pt-4">
            <div className="sui-pt-2">
              <SkeletonLine fullWidth variant="single" />
            </div>
            <div className="sui-pt-2">
              <SkeletonLine variant="single" />
            </div>
          </div>
        </div>
        <div className="sui-w-full sui-p-4">
          <div key={`recentOrdersCarouselSectionTwo${i}`}>
            <CardItemsPlaceholder key={`recentOrdersCardImagePlaceholder${i}`} />
          </div>
          <div className="sui-pt-2" key={`recentOrdersCarouselSectionThree${i}`}>
            <SkeletonBlock height={12} />
          </div>
        </div>

      </div>
    );
  }

  return (
    <Card className="sui-h-full sui-w-full placeholderRecentOrdersCardContainer" data-component="RecentOrdersCardPlaceholder">
      <RecentOrdersCardHeader />
      <Carousel disableMargin disableShadow slidesPerView={1}>
        {cardContent}
      </Carousel>
    </Card>
  );
}
